import { useCallback } from 'react';
import { useParams } from 'react-router-dom';

import useWorkspaceRouter from '@/hooks/domain/useWorkspaceRouter';
import useFetch from '@/hooks/pure/useFetch';

const CustomerDetailRedirection = () => {
  const wc = useWorkspaceRouter();
  const customer_alias = useParams().customer_alias as string;

  const handleRoute = useCallback(async () => {
    if (!customer_alias) return;

    wc.push('/customers', {
      replace: true,
    });
  }, [wc, customer_alias]);

  useFetch(handleRoute);

  return null;
};

export default CustomerDetailRedirection;
